import { SiteIdOverrideConfig } from "stores/wizard/config";

export const siteId80001: SiteIdOverrideConfig = {
  flight: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.flight",
      locSubtitleTextToken: "wizard.travelocity.subLabel.flight",
      differentiatedTitles: true,
    },
  },
  package: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.packages",
      locSubtitleTextToken: "wizard.travelocity.subLabel.packages",
      differentiatedTitles: true,
    },
  },
  hotel: {
    heading: {
      lobSubtitleBreakPoint: "medium",
      locTitleDesktopTextToken: "wizard.travelocity.label.hotel",
      locSubtitleTextToken: "wizard.travelocity.subLabel.hotel",
      differentiatedTitles: true,
    },
  },
};
